export default "__VITE_ASSET__zWHmaZDB__"